import { therapyPlanningAction } from '../../actions/constant';

const {
  GET_PATIENT_THERAPY_PLANNING_FAILURE,
  GET_PATIENT_THERAPY_PLANNING_LOADING,
  GET_PATIENT_THERAPY_PLANNING_SUCCESS,
  GET_PATIENT_THERAPY_PLANNING_RESET
} = therapyPlanningAction;

const intitialstate: object = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
};

export const getTherapyPlanningPatientReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_PATIENT_THERAPY_PLANNING_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
        loading: false,
      };
    }

    case GET_PATIENT_THERAPY_PLANNING_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.paylod,
        response: null,
        loading: false,
      };
    case GET_PATIENT_THERAPY_PLANNING_LOADING:
      return {
        ...intitialstate,
        loading: true,
      };
    case GET_PATIENT_THERAPY_PLANNING_RESET :
      return intitialstate

    default:
      return state;
  }
};
